import SelectTool from '../SelectTool';
import getSymbol from '../../style';

/**
 * 框选工具类
 */
export default class RectSelectTool extends SelectTool {
    bindEvent(map) {
        map.on('mousedown', this.onMouseDown, this);
        map.on('mousemove', this.onMouseMove, this);
        map.on('mouseup', this.onMouseUp, this);
    }

    unbindEvent(map) {
        map.off('mousedown', this.onMouseDown, this);
        map.off('mousemove', this.onMouseMove, this);
        map.off('mouseup', this.onMouseUp, this);
    }

    onMouseDown(mouseEvent) {
        super.onMouseDown(mouseEvent);

        this._dragStart = mouseEvent;
        this.disableMapDraging();
    }

    onMouseMove(mouseEvent) {
        super.onMouseMove(mouseEvent);

        if (this._dragStart) {
            this._dragBox = this._getBox(
                this._dragStart.latlng,
                mouseEvent.latlng
            );

            this.refreshFeedback();
        }
    }

    onMouseUp(mouseEvent) {
        super.onMouseUp(mouseEvent);

        this._dragStart = null;
        this.restoreMapDraging();
        if (this._dragBox) {
            this.selectedFeatures = this._featureSelector.selectByGeometry(this._dragBox, this.options.filter);
            this._dragBox = null;
        } else {
            this.selectedFeatures = [];
        }
        
        this.refreshFeedback();

        this.finish();
    }

    resetFeedback() {
        super.resetFeedback();

        if (this._dragBox) {
            this._feedback.addItems({
                geometry: this._dragBox,
                symbol: getSymbol('drag_region')
            });
        }
    }

    _getBox(minLatlng, maxLatlng) {
        return {
            type: 'Polygon',
            coordinates: [
                [
                    [minLatlng.lng, minLatlng.lat],
                    [maxLatlng.lng, minLatlng.lat],
                    [maxLatlng.lng, maxLatlng.lat],
                    [minLatlng.lng, maxLatlng.lat],
                    [minLatlng.lng, minLatlng.lat]
                ]
            ]
        };
    }
}
